"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BaseLink = void 0;
var _react = _interopRequireWildcard(require("react"));
var _animateScroll = _interopRequireDefault(require("../../utils/animateScroll"));
var _Button = require("../Button");
var _CssClassNames2 = _interopRequireDefault(require("../../scss/CssClassNames"));
var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var _CssClassNames = new _CssClassNames2["default"](_stylesModule["default"], ['utility', 'transition', 'text']),
  getClassName = _CssClassNames.getClassName;
var BaseLink = /*#__PURE__*/(0, _react.memo)(function (_ref) {
  var onClick = _ref.onClick,
    onFocus = _ref.onFocus,
    _ref$Tag = _ref.Tag,
    Tag = _ref$Tag === void 0 ? 'a' : _ref$Tag,
    scheme = _ref.scheme,
    href = _ref.href,
    onClickAlways = _ref.onClickAlways,
    _ref$yScrollPoint = _ref.yScrollPoint,
    yScrollPoint = _ref$yScrollPoint === void 0 ? false : _ref$yScrollPoint,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$titleAlt = _ref.titleAlt,
    titleAlt = _ref$titleAlt === void 0 ? '' : _ref$titleAlt,
    _ref$activeLinkClass = _ref.activeLinkClass,
    activeLinkClass = _ref$activeLinkClass === void 0 ? '' : _ref$activeLinkClass,
    _ref$extraClassName = _ref.extraClassName,
    extraClassName = _ref$extraClassName === void 0 ? '' : _ref$extraClassName,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '_self' : _ref$target,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? 'link' : _ref$type,
    _ref$tabIndex = _ref.tabIndex,
    tabIndex = _ref$tabIndex === void 0 ? null : _ref$tabIndex,
    _ref$fade = _ref.fade,
    fade = _ref$fade === void 0 ? null : _ref$fade,
    _ref$partiallyActive = _ref.partiallyActive,
    partiallyActive = _ref$partiallyActive === void 0 ? false : _ref$partiallyActive,
    id = _ref.id,
    role = _ref.role,
    onMouseEnter = _ref.onMouseEnter,
    _ref$extraAttributes = _ref.extraAttributes,
    extraAttributes = _ref$extraAttributes === void 0 ? {} : _ref$extraAttributes,
    size = _ref.size;
  var handleClick = function handleClick(e) {
    if (onClickAlways) {
      onClickAlways();
    }
    if (onClick) {
      onClick(e);
    } else if (yScrollPoint !== false) {
      e.preventDefault();
      (0, _animateScroll["default"])(yScrollPoint);
    }
  };
  var contents = null;
  if (!titleAlt) {
    titleAlt = title;
  }
  var sharedParams = {
    onClick: handleClick
  };
  if (onFocus) {
    sharedParams.onFocus = onFocus;
  }
  if (onMouseEnter) {
    sharedParams.onMouseEnter = onMouseEnter;
  }
  if (tabIndex !== null) {
    sharedParams.tabIndex = tabIndex;
  }
  if (id) {
    sharedParams.id = id;
  }
  if (role) {
    sharedParams.role = role;
  }
  if (scheme === 'gatsby') {
    contents = /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, sharedParams, extraAttributes, {
      className: getClassName("".concat(extraClassName)),
      activeClassName: getClassName("".concat(activeLinkClass)),
      to: href,
      "data-title": typeof title === 'string' ? title : '',
      title: typeof titleAlt === 'string' ? titleAlt : '',
      "aria-label": typeof titleAlt === 'string' ? titleAlt : ''
    }, fade && {
      fade: fade
    }, partiallyActive && {
      partiallyActive: partiallyActive
    }, {
      target: target
    }), typeof title === 'string' ? /*#__PURE__*/_react["default"].createElement("span", null, title) : title);
  } else if (scheme === 'button') {
    contents = /*#__PURE__*/_react["default"].createElement(_Button.Button, _extends({}, sharedParams, {
      Tag: Tag,
      type: type,
      href: href,
      target: target,
      size: size ? size : null,
      className: getClassName("".concat(extraClassName)),
      extraAttributes: _objectSpread(_objectSpread({}, extraAttributes), {}, {
        title: typeof titleAlt === 'string' ? titleAlt : '',
        'aria-label': typeof titleAlt === 'string' ? titleAlt : ''
      })
    }), title);
  } else {
    contents = /*#__PURE__*/_react["default"].createElement(Tag, _extends({}, sharedParams, extraAttributes, {
      className: getClassName("".concat(extraClassName)),
      href: href,
      "data-title": typeof title === 'string' ? title : '',
      title: typeof titleAlt === 'string' ? titleAlt : '',
      "aria-label": typeof titleAlt === 'string' ? titleAlt : '',
      target: target
    }), typeof title === 'string' ? /*#__PURE__*/_react["default"].createElement("span", null, title) : title);
  }
  return contents;
});
exports.BaseLink = BaseLink;